import * as S from '../styles';

const ContractConditionInfo = () => {
  return (
    <S.Wrapper isConnect>
      <S.Title type='page'>계약 조건</S.Title>

      <S.Section type='paragraph'>
        <S.Title type='section'>
          1.계약서에 기재된 운전자만 운전이 가능하며{' '}
          <S.Text type='highlight' fontSize='18px' fontWeight={600}>
            계약자 이외 운전자 사고 발생 시 종합보험 및 차량 손해
            면책(자차보험), 특약 처리가 불가
          </S.Text>
          합니다.
        </S.Title>
        <S.Section type='text'>
          <S.Text type='main'>- 최대 2인까지 등록 가능합니다.</S.Text>
        </S.Section>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          2. 차량은 차량 손해 면책(자차보험) 계약을 제외한 종합보험에 가입되어
          있습니다.
        </S.Title>
        <S.Section type='text'>
          <S.Text type='main'>
            - 대인:무한, 대물 한도:2,000만 원, 자손 한도:1,500만 원 <br />
            <S.Text type='highlight'>
              - 대인 접수 시 : 1인 기준 고객 부담 30만원 <br />
              - 대물 접수 시 : 1건 기준 고객 부담 50만원 <br />
              - 자손 접수 시 : 1인 기준 고객 부담 30만원 <br />
              <br />
              - 한도 초과 시 임차인 부담 <br />
              - 계약서에 등록된 운전자는 사고 발생 시, 자손 보험으로 처리
              <br />
            </S.Text>
          </S.Text>
        </S.Section>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          3. 임차 기간 중 사용한 연료는 임차인이 부담합니다.
        </S.Title>
        <S.Section type='text'>
          <S.Text type='main'>
            - 출고 시 연료와 동일하게 반납해야 하며, 반납 시 연료 부족분은
            임차인이 부담합니다.
          </S.Text>
        </S.Section>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          4. 차량 임차 중에 발생한 주정차 위반과 교통법규 위반 사항은 반환 후
          임차인이 책임집니다.
        </S.Title>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>5. 렌트카는 본사 반납이 원칙입니다.</S.Title>
        <S.Section type='text'>
          <S.Text type='main'>
            - 반납 시간 미준수 시 추가 요금이 발생합니다.
          </S.Text>
        </S.Section>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          6. 임차 기간에 사용 연장을 원하실 경우 당사 근무시간 08:00~19:00
          이내에 연락하여 연장 가능 여부를 확인해야 합니다.
        </S.Title>
        <S.Section type='text'>
          <S.Text type='main'>
            <S.Text type='highlight'>
              - 당사 상황에 따라 사용 연장이 불가능할 수 있습니다. <br />
            </S.Text>
            - 당사와 협의되지 않은 차량 무단 사용 연장 및 임차인의 일방적인 통보
            후 사용 연장 시 임차인은 차량 반납 예정 시각으로부터 실제 반납
            시각까지의 <br />
            &nbsp;&nbsp;시간 동안 해당 차량의 대여요금이 아닌 정상요금으로
            부과됩니다. <br />
            <S.Text type='highlight'>
              - 반납 예정 시간 이후의 사고는 종합보험 및 자차보험 적용이
              불가하며, 임차인이 수리 비용+휴차보상료+격락 손해비용 등 전액을
              부담합니다. <br />
            </S.Text>
            - 차량 교의, 무단 방치, 미반납은 민·형사상 처벌을 받을 수 있습니다.{' '}
            <br />
            - 다음 임차인의 차량 인수를 못함으로 인한 차량 변경 비용 등 처리
            비용이 청구됩니다. <br />
          </S.Text>
        </S.Section>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          7. 조기 반납은 임차인의 요청에 의한 것이므로 남은 임차 시간과
          자차보험은 차량 반납과 동시에 자동 소멸됩니다.
        </S.Title>
        <S.Section type='text'>
          <S.Text type='main'>
            - 환불금 및 조기 반납 시간 적용은 본사 반납 시간 기준 24시간 이전이
            원칙이나 예약한 여행사에 따라 상이할 수 있습니다.
          </S.Text>
        </S.Section>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          8. 차량 손해 면책은 가입과 동시에 적용되며 별도의 영수증을 제공하지
          않고 문자 발송된 전자계약서로 대신합니다.
        </S.Title>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          9. 차량 반납 후 분실물에 대해서는 책임지지 않습니다.
        </S.Title>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          10. 무상으로 제공되는 네비게이션, 전·후방 센서, 후방카메라의 오류 및
          고장으로 인해 발생하는 사고 및 손실은 당사에서는 책임지지 않습니다.
        </S.Title>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          11. 당사에서는 엔진 고장 및 구동 장치 관련 결함을 제외한 나머지
          사유로는 현장 출동을 하지 않습니다.
        </S.Title>
        <S.Section type='text'>
          <S.Text type='main'>
            - 혹 현장 출동 후 결함이 없거나, 운전자 조작 미숙으로 확인될 경우
            출동 비용은 임차인이 부담합니다. (비용은 출동 위치에 따라 상이){' '}
            <br />- 단, 본사 방문 시 차량 교체 가능하며 예약 상황에 따라 다른
            차량으로 배차될 수 있습니다.
          </S.Text>
        </S.Section>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          12. 모든 차량은 금연 차량이며, 반려동물 동반 및 낚시 이용객에 제한을
          두고 있습니다.
        </S.Title>
        <S.Section type='text'>
          <S.Text type='main'>
            - 위반 시 클리닝 비용(10만원~20만원)을 부과합니다. 미납 시 법적
            조치를 받을 수 있습니다.
          </S.Text>
        </S.Section>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          13. 사고 발생 시 계약 해지가 원칙이며, 계약 해지 여부는 당사에서
          결정합니다.
        </S.Title>
      </S.Section>
      <S.Section type='paragraph'>
        <S.Title type='section'>
          14. 대여 자격 기준에 적합하나 운전 미숙으로 차량 운행이 불가하다 판단
          시에는 고객 안전을 위해 렌트카 계약은 해지 될 수 있습니다.
        </S.Title>
        <S.Section type='text'>
          <S.Text type='main'>
            - 운전 미숙 판단 여부는 당사에서 결정합니다.
          </S.Text>
        </S.Section>
      </S.Section>
    </S.Wrapper>
  );
};

export default ContractConditionInfo;
